
import Framework from '@geek/yum-freight-framework'
import YunIcon from '@yld/yun-icon'
import './assets/element.scss'
import Vue from 'vue'

const serverConfig = require('../serverConfig.json')

Vue.prototype.$eventBus = new Vue()
const app = new Framework({
  serverConfig
})

app.use(YunIcon)
app.start()
